export enum ExportKey {
  EXPORT_TYPE = "exportType",
  EXPORT_CSV_DELIMITER = "exportCsvDelimiter",
  FREQUENCY_AUTO_EXPORT = "frequencyAutoExport",
  AUTO_EXPORT_ENABLED = "autoExportEnabled",
  EXPORT_TO_FILE = "exportToFile",
  EXPORT_OUTPUT_MODE = "exportOutputMode",
  EXPORT_WEBSERVICE = "exportWebService",
  EXPORT_FILE_DESTINATION = "exportFileDestination",
  EXPORT_TIME = "exportTime",
  EXPORT_TIME_FORMAT = "exportTimeFormat",
  EXPORT_FILE_PATTERN = "exportFilePattern",
  MANUAL_EXPORT_FILE_PATTERN = "manualExportFilePattern",
}
